import { render, staticRenderFns } from "./PublicSocialLoginFacebook.vue?vue&type=template&id=30986b1a"
import script from "./PublicSocialLoginFacebook.vue?vue&type=script&lang=ts"
export * from "./PublicSocialLoginFacebook.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports